import { ChangeDetectorRef, Component, Input, NgZone, OnInit, inject } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-cd-step',
  templateUrl: './cd-step.component.html',
  styleUrls: ['./cd-step.component.scss'],
  imports: [NgClass],
})
export class CdStepComponent implements OnInit {
  private changeDetectorRef = inject(ChangeDetectorRef);
  private zone = inject(NgZone, { optional: true }) ?? ({ run: <T>(fn: () => T) => fn() } as NgZone);

  @Input() label!: string;
  private isFinish = false;

  constructor() {}

  ngOnInit(): void {}

  setLabel(val: string) {
    Promise.resolve().then(() => {
      this.updateView(() => {
        this.label = val;
      });
    });
  }

  setFinish() {
    this.updateView(() => {
      this.isFinish = true;
    });
  }

  setUnfinished() {
    this.updateView(() => {
      this.isFinish = false;
    });
  }

  get finishStatus() {
    return this.isFinish;
  }

  private updateView(fn: () => void) {
    this.zone.run(() => {
      fn();
      this.changeDetectorRef.detectChanges();
    });
  }
}
